import Vue from 'vue'

import {
  DatePicker,
  ColorPicker,
  Select,
  Option as ElOption,
  OptionGroup,
  Tag,
  Input,
} from 'element-ui'
import elLocale from 'element-ui/lib/locale'
import elLang from 'element-ui/lib/locale/lang/en'

// Vue.component('v-select', VSelect)

// configure element language
elLocale.use(elLang)

Vue.component(Input.name, Input)
Vue.component(DatePicker.name, DatePicker)
Vue.component(ColorPicker.name, ColorPicker)
Vue.component(Select.name, Select)
Vue.component(ElOption.name, ElOption)
Vue.component(OptionGroup.name, OptionGroup)
Vue.component(Tag.name, Tag)
